module.exports = __webpack_public_path__ + "static/media/bottom1.c8b1b8a9.webp";